import { createAction, props } from "@ngrx/store";
import { CheckMobileCodeModel, SendMobileCodeModel } from "src/app/model/check-mobile-code.model";
import { SendMobileCodeResponseModel } from "src/app/model/member-join.model";
import { OkModel } from "src/app/model/ok.model";

export const ResetDataSavedAction = createAction('[Mobile Verification Form] reset data saved property');

export const SetMobileAction = createAction('[Mobile Verification Form] set mobile',
  props<{ mobile: string }>());

export const CheckMobileCodeRequestAction = createAction('[Mobile Verification Form] CheckMobileCode  request',
  props<{ data: CheckMobileCodeModel }>());

export const CheckMobileCodeResponseAction = createAction('[Mobile Verification Form] CheckMobileCode  response',
  props<{ data: OkModel<boolean> }>());

export const SendMobileCodeRequestAction = createAction('[Mobile Verification Form] sendMobileCode  request',
  props<{ data: SendMobileCodeModel }>());

export const SendMobileCodeResponseAction = createAction('[Mobile Verification Form] sendMobileCode  response',
  props<{ data: SendMobileCodeResponseModel }>());